import { Injectable } from '@angular/core';
import { CoreService } from './core.service';
import { AppSettings } from '../config';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private htmlElement: HTMLHtmlElement;

  constructor(private coreService: CoreService) {
    this.htmlElement = document.querySelector('html')!;
    // Apply initial theme on service creation
    this.applyCurrentTheme();
  }

  /**
   * Sets the theme (light or dark) and applies it to the DOM
   */
  setTheme(theme: 'light' | 'dark'): void {
    if (theme === 'light' || theme === 'dark') {
      // Update CoreService options
      this.coreService.setOptions({ theme: theme });
      
      // Save to localStorage
      localStorage.setItem("bilgebot-theme", theme);
      
      // Apply theme classes to HTML element
      this.applyThemeClasses(theme);
    }
  }

  /**
   * Gets the current theme from CoreService
   */
  getCurrentTheme(): 'light' | 'dark' {
    return this.coreService.getOptions().theme as 'light' | 'dark';
  }

  /**
   * Gets the current options from CoreService
   */
  getOptions(): AppSettings {
    return this.coreService.getOptions();
  }

  /**
   * Applies the current theme from CoreService to the DOM
   */
  applyCurrentTheme(): void {
    const currentTheme = this.getCurrentTheme();
    this.applyThemeClasses(currentTheme);
  }

  /**
   * Applies theme CSS classes to the HTML element
   */
  private applyThemeClasses(theme: 'light' | 'dark'): void {
    if (theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }

  /**
   * Toggles between light and dark theme
   */
  toggleTheme(): void {
    const currentTheme = this.getCurrentTheme();
    const newTheme = currentTheme === 'light' ? 'dark' : 'light';
    this.setTheme(newTheme);
  }
}